<template>
  <c-modal title='Specify request properties' v-model="open" size="lg">
      <c-scroll-view style="height:600px">
          <span v-for="f in files" v-bind:key="f.id">
              <c-row>
                  <c-col>
                      <span class="u-font-bold">{{f.fileName}}</span>
                  </c-col>
                <c-col>
                  <c-button icon-start="icon-bin" outline smart size="sm" v-if="!f.skip" @click="onRemove(f)">Remove</c-button>
                  <c-button icon-start="icon-undo" outline smart size="sm" v-if="f.skip" @click="onUndoRemove(f)">Undo remove</c-button>
                </c-col>
              </c-row>
            <c-row v-if="!f.skip">
              <div v-for="p in props" v-bind:key="p.property_code">
                <div v-if="p.allows_manual_input && p.is_visible">
                  <c-col offset="8" span="24">{{p.property_display_name}} <i class="u-fs-12 u-color-grey-light">{{reqIndicator(p)}}</i></c-col>
                  <c-col offset="8" span="24">
                    <c-form-input v-model="f[p.property_code]" v-if="p.property_type === 'string'" ></c-form-input>
                    <c-form-select v-model="f[p.property_code]" v-if="p.property_type.startsWith('enum')" :options="enumValues(p.property_type)"></c-form-select>
                  </c-col>
                </div>
              </div>
            </c-row>
            <c-row>
              <c-col>&nbsp;</c-col>
            </c-row>
          </span>
              <c-row>
                  <c-col>
                    <c-button type="success" @click="onContinue">Continue</c-button>
                    <c-button @click="onCancel">Cancel</c-button>
                  </c-col>
              </c-row>
            <c-row>
              <c-col>&nbsp;</c-col>
            </c-row>
      </c-scroll-view>
  </c-modal>
</template>

<script>
export default {
  name: 'FileUploadRequestProperties',

  data () {
    return {
      open: false,
      files: [],
      props: [],
      origFiles: null,
      uploadComponent: null
    }
  },
  methods: {
    enumValues (vals) {
      let s = vals.substring(5)
      let v = s.split('|')
      let ret = []
      for (const sv of v) {
        ret.push({
          value: sv,
          label: sv
        })
      }

      return ret
    },

    show (files, props, uploadComponent) {

      if (this.open) {
        return
      }

      this.files = []
      this.props = props
      this.origFiles = files
      this.uploadComponent = uploadComponent

      let i = 0
      for (const f of files) {
        if (f.active || f.success || f.error) {
          continue
        }
        let o = {
          id: i,
          fileName: f.name,
          fileObject: f,
          skip: false
        }
        i++

        for (const p of props) {
          if (p.is_visible && p.allows_manual_input) {
            o[p.property_code] = ''
          }
        }

        this.files.push(o)
      }

      if (this.files.length > 0) {
        this.open = true
      }
    },

    onContinue () {
      // validate the records that will be uploaded
      let messages = []
      for (const f of this.files) {
        if (f.skip) continue
        for (const p of this.props) {
          if (p.is_mandatory && p.is_visible && (f[p.property_code] == null || f[p.property_code] === '')) {
            messages.push(`${f.fileName}`)
            break
          }
        }
      }
      let h = '<ul><li>'
      h += messages.join('</li><li></li>')
      h += '</li></ul>'
      if (messages.length > 0) {
        this.$snotify.error('Please specify the required properties for all files you want to upload', {
          position: 'centerTop',
          timeout: 6000,
          showProgressBar: false,
          html: h
        })
      } else {
        // everything is OK, let's commit
        for (const f of this.files) {
          if (f.fileObject.active || f.fileObject.success || f.fileObject.error) {
            continue
          }
          if (f.skip) {
            this.uploadComponent.remove(f.fileObject.id)
          } else {
            for (const p of this.props) {
              if (p.is_visible && p.allows_manual_input) {
                f.fileObject.data[p.property_code] = f[p.property_code]
              }
            }
            this.uploadComponent.update(f.fileObject.id, {active: true})
          }
        }

        this.open = false
      }
    },

    performUpload () {
      this.open = false
    },

    onCancel () {
      while (this.files.length) {
        let f = this.files.pop()
        this.uploadComponent.remove(f.fileObject.id)
      }
      this.open = false
    },

    onRemove (file) {
      file.skip = true
    },

    onUndoRemove (file) {
      file.skip = false
    },

    validate (file, prop) {
      if (file.skip) return ''
      if (prop.is_mandatory) {
        return 'required'
      }

      return ''
    },

    reqIndicator (prop) {
      if (prop.is_mandatory) {
        return '(required)'
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FileUploadRequestProperties.vue